<a mat-button [routerLink]="link">
  <mat-icon color="primary">chevron_right</mat-icon>
  {{ label }}
</a>
